import { combineReducers } from "@reduxjs/toolkit";

import teeTime from "./teeTime/reducer";
import bookings from "./bookings/reducer";

import header from "./header/reducer";
import facilities from "./facilities/reducer";
import clubs from "./clubs/reducer";
import courses from "./courses/reducer";
import footers from "./footers/reducer";
import menu from "./menu/reducer";
import users from "./users/reducer";
import setting from "./setting/reducer";
import payment from "./payment/reducer";
import tournamentPayment from "./tournamentPayment/reducer";
import competition from "./competition/reducer";

const rootReducer = combineReducers({
  teeTime,
  bookings,

  header,
  facilities,
  clubs,
  courses,
  footers,
  menu,
  users,
  setting,
  payment,
  tournamentPayment,
  competition,
});

export default rootReducer;
